import React from 'react';
import { isNil } from 'lodash';

import { getCreatorFullName } from 'utils/personUtils';
import { CreatorUserModel } from 'api/backofficeApiClient';

type Props = {
  label: string;
  creator?: CreatorUserModel | null;
  children?: React.ReactNode;
};

export default function BasePageLabel(props: Props) {
  const { label, creator, children } = props;

  return (
    <div className="title-line">
      <span className="title-line__text">{label}</span>

      <span className="title-line__line" />

      {!isNil(creator) && (
        <span className="title-line__created">
          <span>Created by: </span>
          {getCreatorFullName(creator?.fullName)}
        </span>
      )}

      {children && <>{children}</>}
    </div>
  );
}
